<script setup>
import editSvg from '@/assets/images/edit.svg'
</script>

<template>
  <img alt="" :src="editSvg" class="draft-icon">
</template>
